// extracted by mini-css-extract-plugin
module.exports = {"root":"Question_root__3uR1w","question":"Question_question__35XcO","description":"Question_description__15P6p"};